import React, { useEffect, useState } from "react";
import { Box, Container, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { MuiTelInput } from "mui-tel-input";

import { API_ENDPOINT } from "../utils/constants";
import { getDbHeader, toastError } from "../utils/util";

const ServiceBadge = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(false);

  const [exhibitorId, setExhibitorId] = useState("");
  const [phoneValue, setPhoneValue] = useState("");

  useEffect(() => {
    document.title = "SERVICE BADGE";
  }, []);

  const onClickSubmit = async () => {
    if (!exhibitorId.trim()) {
      toast.error("Please enter an Exhibitor ID.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(
        `${API_ENDPOINT}/onsite/get-service-badge-person?id=${exhibitorId}`,
        getDbHeader()
      );

      if (response.status === 200) {
        navigate(`/service-badge/${response.data.exhibitorId}`);
      } else if (response.status === 204) {
        toast.info("No Exhibitor Found with that ID.");
      }
    } catch (error) {
      toastError(error);
    } finally {
      setLoading(false);
    }
  };

  const onClickMobileSubmit = async () => {
    if (!phoneValue.trim()) {
      toast.error("Please enter mobile number");
      return;
    }

    const phoneWithoutSpaces = phoneValue.replace(/\s+/g, "");
    setChecking(true);

    try {
      const response = await axios.get(
        `${API_ENDPOINT}/onsite/get-service-badge-person-mobile?id=${encodeURIComponent(
          phoneWithoutSpaces
        )}`,
        getDbHeader()
      );

      if (response.status === 200) {
        navigate(`/service-badge-preview/${phoneWithoutSpaces}`);
      } else if (response.status === 204) {
        toast.info("Your mobile number is not registered");
      }
    } catch (error) {
      toastError(error);
    } finally {
      setChecking(false);
    }
  };

  return (
    <Box mt={4}>
      <Container maxWidth="sm">
        <Typography
          mb={4}
          color="#972a4c"
          textAlign={"center"}
          fontWeight="bold"
          fontSize="28px"
        >
          Service Badge
        </Typography>

        <TextField
          value={exhibitorId}
          onChange={(e) => setExhibitorId(e.target.value)}
          fullWidth
          label="Enter Exhibitor ID"
        />

        <LoadingButton
          fullWidth
          loading={loading}
          sx={{ mt: 3, mb: 4 }}
          onClick={onClickSubmit}
          variant="contained"
        >
          Proceed
        </LoadingButton>

        <Typography sx={{ mt: 2, mb: 2 }} variant="h6">
          Already registered? Please enter Mobile number to view your Badge.
        </Typography>

        <MuiTelInput
          size="small"
          fullWidth
          defaultCountry="IN"
          value={phoneValue}
          onChange={setPhoneValue}
        />

        <LoadingButton
          sx={{
            mt: 3,
            backgroundColor: "#972a4c",
            "&:hover": {
              backgroundColor: "#7a1e3a",
            },
          }}
          fullWidth
          loading={checking}
          onClick={onClickMobileSubmit}
          variant="contained"
        >
          Preview Badge
        </LoadingButton>
      </Container>
    </Box>
  );
};

export default ServiceBadge;
